export default "__VITE_ASSET__DbeOC5xz__"